<style lang="less" scoped>
.query-title-div {
  width: 90px !important;
}

.lang-width {
  width: 450px !important;
}

.list-content-div {
  margin-top: 16px;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">故障详情列表</div>
      <ZD-list-querys> </ZD-list-querys>
      <div class="page-action-btns flex margin-tb-10">
        <button class="common-bg-button" @click="addRemarkFun()">备 注</button>
        <div class="flex-1"></div>
        <el-date-picker size="small" style="width:320px;margin-right:10px;" v-model="queryInfo.fromTime"
          value-format="yyyy-MM-01 00:00:00" format="yyyy-MM-01 00:00:00" type="month"
          placeholder="请选择故障日期"></el-date-picker>
        <button class="common-bg-button" @click="getWarnListData(pagination, true)">搜索</button>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table :tableColumns="pageConfig.faultRecordColumns" :operates="operates" :tableData="tableData"
          :tableConfig="pageConfig.tableConfig" :selections="selections"
          v-on:updateSelections="(sels) => { selections = sels }"></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getWarnListData"></ZD-pagination>
      </div>
      <el-dialog title="备注" :visible.sync="dialogFormVisible">
        <el-form :model="repairForm">
          <el-form-item label="请输入备注">
            <el-input v-model="repairForm.remark" autocomplete="off" type="textarea" :rows="5"
              placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogSubmit()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import utils from '../../../utils/utils'
import config from '../../../config/config'
import pageConfig from './page-config'
import axios from 'axios'
export default {
  data() {
    return {
      pageConfig,
      pagination: pageConfig.pagination,
      // 默认值设置
      detailForm: {},
      queryInfo: {},
      repairForm: {},
      operates: {
        width: 220,
        fixed: 'right',
        list: [],
      }, // 列操作按钮
      tableData: [], // 表格数据
      selections: [], // 表格选项
      dialogFormVisible: false,
    }
  },
  methods: {
    init() {
      this.getFormInfo()
    },
    // 获取表单信息
    getFormInfo() {
      let _ = this
      _.$S.getFormInfo(
        _,
        _.$A.pile.list + '/' + _.$store.state.editId,
        function (res) {
          _.detailForm = res.data.data
          _.queryInfo.rcsCode = _.detailForm.pileCode
          _.getWarnListData(_.pagination)
        }
      )
    },
    //选择表格
    checkSelectOne() {
      if (this.selections.length < 1) {
        this.$U.error('请选择需要操作的对象')
        return false
      }
      if (this.selections.length > 1) {
        this.$U.error('只能选择一个操作的对象')
        return false
      }
      return true
    },
    //点击备注
    addRemarkFun() {
      if (this.checkSelectOne()) {
        let _ = this
        this.dialogFormVisible = true
        _.repairForm = _.selections[0]
      }
    },
    //搜索
    getWarnListData(pagination, reload = false) {
      let _ = this

      _.$U.showLoading(_)
      _.queryInfo.pageNum = pagination.current - 1
      if (reload) {
        _.queryInfo.pageNum = 0
      }
      _.queryInfo.pageSize = pagination.pageSize

      axios
        .post(_.$A.pile.pileWarn, _.queryInfo, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            authorization: _.$store.state.token,
          },
          timeout: config.httpTimeOut,
        })
        .then((res) => {
          _.tableData = res.data.content || []
          _.pagination.total = res.data.totalElements || 0
          _.$U.hideLoading(_)
        })
        .catch((err) => {
          utils.error('请求失败')
        })
    },
    // 提交表单
    dialogSubmit() {
      let _ = this
      axios
        .post(_.$A.pile.warn, _.repairForm, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            authorization: _.$store.state.token,
          },
          timeout: config.httpTimeOut,
        })
        .then((res) => {
          this.dialogFormVisible = false
          _.getWarnListData(_.pagination)
        })
        .catch((err) => {
          utils.error('请求失败')
        })
    },
  },
  mounted() {
    this.init()
  },
}
</script>
